<template>
  <div
    v-if="this.swiper && !(this.swiper.isBeginning && this.swiper.isEnd)"
    class="pagination"
    :class="text.length ? 'pagination--text' : ''"
  >
    <button class="pagination__arrow pagination__arrow--left" @click="swiper.slidePrev()"></button>
    <p>{{ text }}</p>
    <div class="pagination__items">
      <button
        class="pagination__item"
        :class="swiper.realIndex === index ? 'pagination__item--active' : ''"
        v-for="index in swiperDotsArray"
        :key="index"
        @click="changeSlide(index)"
      ></button>
    </div>
    <button class="pagination__arrow pagination__arrow--right" @click="swiper.slideNext()"></button>
  </div>
</template>

<script>
import '@/assets/sass/pagination.sass';

export default {
  name: 'Pagination',
  props: {
    swiper: {
      default: () => {},
      type: Object,
    },
    text: {
      default: () => '',
      type: String,
    },
  },
  computed: {
    swiperDotsArray() {
      if (this.text.length) return [];
      if (!this.swiper) return [];

      const { params, slides } = this.swiper;
      const { slidesPerView, grid } = params;
      const slidesPerColumn = grid ? grid.rows || 1 : 1;

      const pages = Math.ceil((slides.length - slidesPerView * slidesPerColumn + slidesPerColumn) / slidesPerColumn);

      if (pages <= 1) return [];

      return [...Array(pages).keys()];
    },
  },
  methods: {
    changeSlide(index) {
      this.swiper.slideTo(index);
    },
  },
};
</script>
